import React, { createContext, useContext, useState } from 'react'

export enum Vertical {
  Furniture = 'furniture',
  Lighting = 'lighting',
  Clothes = 'clothes',
  Shoes = 'shoes',
  Jewelry = 'jewelry',
  Electronics = 'electronics',
}

interface IHomepageContext {
  selectedVertical: Vertical | undefined
  setSelectedVertical: (value: Vertical | undefined) => void
  inputFocused: boolean
  setInputFocused: (value: boolean) => void
}

const defaultContext = {
  selectedVertical: undefined,
  setSelectedVertical: () => {},
  inputFocused: false,
  setInputFocused: () => {},
}

export const HomePageContext = createContext<IHomepageContext>(defaultContext)

export const useHomePageContext = () => {
  const context = useContext(HomePageContext)

  if (context === undefined) {
    throw new Error(
      'useHomePageContext() must be used within a HomePageProvider'
    )
  }

  return context
}

export const HomePageProvider = ({ children }: React.PropsWithChildren) => {
  const [inputFocused, setInputFocused] = useState(false)
  const [selectedVertical, setSelectedVertical] = useState<
    Vertical | undefined
  >()

  return (
    <HomePageContext.Provider
      value={{
        selectedVertical,
        setSelectedVertical,
        inputFocused,
        setInputFocused,
      }}
    >
      {children}
    </HomePageContext.Provider>
  )
}
